import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M21 21l-6 -6","key":"svg-1"}],["path",{"d":"M7 10l2 2l4 -4","key":"svg-2"}]]

/**
 * IconZoomCheck
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9vbS1jaGVjayIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxMGE3IDcgMCAxIDAgMTQgMGE3IDcgMCAxIDAgLTE0IDAiIC8+CiAgPHBhdGggZD0iTTIxIDIxbC02IC02IiAvPgogIDxwYXRoIGQ9Ik03IDEwbDIgMmw0IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zoom-check
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZoomCheck = createReactComponent('outline', 'zoom-check', 'ZoomCheck', __iconNode);

export default IconZoomCheck;